import sesionUsuarioReducer from './sesionUsuarioReducer';
import openSnackbarReducer from './openSnackbarReducer';

export const mainReducer = ({sesionUsuario, openSnackbar, drawer, institution}, action) => {
    return {
        sesionUsuario : sesionUsuarioReducer(sesionUsuario, action),
        openSnackbar :  openSnackbarReducer(openSnackbar, action),
        drawer: action.type === "TOGGLE_DRAWER" ? { ...drawer, isCollapsed: !drawer.isCollapsed } : drawer,
        institution: action.type === "SET_INSTITUTION" ? action.value : institution
    }
}